<template>
  <card>
    <!-- Card header -->
    <h5 slot="header" class="h3 mb-0">
      <i class="fas fa-info"></i>
      Angebotsdaten
    </h5>

    <!-- Card body -->
    <div class="list-group list-group-flush">
      <div class="list-group-item">
        <data-row
          title="Kundendaten"
          icon="fas fa-users"
          editable="true"
        >
          <small>
          <!-- i class="fas fa-check"></i -->
offer.customer_first_name -> {{  offer.customer_first_name }} <br>
offer.customer_last_name -> {{  offer.customer_last_name }} <br>
offer.is_company -> {{  offer.is_company }} <br>
offer.company_name -> {{  offer.company_name }} <br>
offer.nosf -> {{  offer.nosf }} <br>
offer.customer_sf -> {{  offer.customer_sf }} <br>
offer.customer_sf2 -> {{  offer.customer_sf2 }} <br>
offer.dob -> {{  offer.dob }} <br>
offer.has_holder -> {{  offer.has_holder }} <br>
offer.holder_id  -> {{  offer.holder_id  }} <br>
offer.kravag_location_id -> {{  offer.kravag_location_id }} <br>
offer.holder_kravag_location_id -> {{  offer.holder_kravag_location_id }} <br>
offer.youngest_driver_dob -> {{  offer.youngest_driver_dob }} <br>
offer.oldest_driver_dob -> {{  offer.oldest_driver_dob }} <br>
offer.insurance_start -> {{  offer.insurance_start }} <br>
offer.holder_zip -> {{  offer.holder_zip }} <br>
offer.holder_id -> {{  offer.holder_id }} <br>
          </small>
        </data-row>
      </div>

      <!-- div class="list-group-item">
        <data-row
          title="Anwaltliche Vertretung"
          icon="fas fa-balance-scale"
          editable="true"
          @click="claim.showLawyer = true" v-scroll-to="'#selectLawyer'"
        >
          <small>
            <template v-if="claim.hasLawyer">
              Ja, vertreten durch:
              {{ claim.lawyerSelection }}
            </template>
            <template v-else> Nein </template>
          </small>
        </data-row>
      </div -->


      <div class="list-group-item">
        <data-row
          title="Fahrzeugdaten"
          icon="fas fa-car"
          editable="true"
        >
          <small>
offer.car_brand -> {{ offer.car_brand }} <br>
offer.car_ccm -> {{ offer.car_ccm }} <br>
offer.car_haftpflicht -> {{ offer.car_haftpflicht }} <br>
offer.car_kw -> {{ offer.car_kw }} <br>
offer.car_model -> {{ offer.car_model }} <br>
offer.car_ps -> {{ offer.car_ps }} <br>
offer.car_teilkasko -> {{ offer.car_teilkasko }} <br>
offer.car_vollkasko -> {{ offer.car_vollkasko }} <br>
offer.car_hsn -> {{ offer.car_hsn }} <br>
offer.car_tsn -> {{ offer.car_tsn }} <br>
offer.car_first_registration -> {{ offer.car_first_registration }} <br>
offer.car_usage -> {{ offer.car_usage }} <br>
offer.car_mileage -> {{ offer.car_mileage }} <br>
offer.mileage -> {{ offer.mileage }} <br>
          </small>
        </data-row>
      </div>

      <div class="list-group-item">
        <data-row
          title="Einstufungsgründe"
          icon="fas fa-user"
          editable="true"
        >
          <small>
            PKW {{ offer.is_car }}<br>
            LKW {{ offer.is_van }}<br>
            Halter {{ offer.holder_id }}<br>
           List {{ offer.leveling_list }}<br>
            Value {{ offer.leveling_type_list }}<br>
            Einstufungsgrund {{ offer.leveling_type }}
          </small>
        </data-row>
      </div>



      <div class="list-group-item">
        <data-row
          title="Versdata"
          icon="fas fa-user"
          editable="true"
        >
          <small>
offer.participation -> {{ offer.participation }} <br>
offer.paymentterm -> {{ offer.paymentterm }} <br>

offer.holder_only_driver -> {{ offer.holder_only_driver }}<br>
 offer.holder_id -> {{ offer.holder_id }}<br>
  offer.second_vehicle_holder -> {{ offer.second_vehicle_holder }}<br>
  offer.sf_holder_sf -> {{ offer.sf_holder_sf }}<br>


          </small>
        </data-row>
      </div>

      <!-- div class="list-group-item">
        <data-row
          title="Kundendaten"
          icon="fas fa-user"
          editable="true"
          @click="claim.showCustomerAddress = true" v-scroll-to="'#customerAddress'"
        >
          <small>
            <template v-if="customerAddress.isCompany">
              Kunde ist ein Unternehmen
              <template v-if="customerAddress.deductVat"
                >(Vorsteuerabzugsberechtigt)</template
              >
              <br />
              {{ customerAddress.companyName }}
              <br />
            </template>

            {{ customerAddress.firstName }} {{ customerAddress.lastName }}
            <br />
            {{ customerAddress.street }} {{ customerAddress.number }}
            <br />
            {{ customerAddress.zip }} {{ customerAddress.city }}
            <br />
            {{ customerAddress.email }}
            <br />
            {{ customerAddress.phone }}
          </small>
        </data-row>
      </div -->
    </div>


    <!-- base-button type="primary" class="btn btn-primary" v-on:click="$emit('custom')" :disabled="!claim.allValidated"
      >Speichern und weiter</base-button -->
        <!-- base-button type="primary" class="btn btn-primary" v-on:click="$emit('custom')"
      >Speichern und weiter</base-button
    -->
    <!-- base-button type="primary" class="btn btn-primary" @click="toggleSummary()"
      >Speichern und weiter</base-button
    -->

    <!-- base-button type="primary" class="btn btn-primary" v-on:click="$emit('billingAddressFinished')"><i class="far fa-save"></i> Bestätigen</base-button -->
  </card>
</template>
<script>
import { mapState } from "vuex";
import DataRow from "./elements/DataRow";
import moment from 'moment';

export default {
  name: "offer-info",
  components: {
    DataRow,
  },
  data() {
    return {};
  },
  methods: {
    formatDate(date) {
      return moment(date).format("DD.MM.YYYY h:mm")
    },
  },
  computed: {
    ...mapState({
      offer: (state) => state.offer,
    }),
  },
};
</script>
<style>
</style>